<div>
  <a *ngIf="!audioLoaded && !audioLoading"
     (click)="load($event);"
     class="fa fa-play-circle fa-lg"
     tooltip="Load audio"
     container="body">
  </a>
  <span *ngIf="!audioLoaded && audioLoading"
        class="fa fa-spinner fa-spin fa-lg">
  </span>
</div>
<plyr *ngIf="audioLoaded"
      plyrType="audio"
      [plyrOptions]="{controls: getControlsType()}"
      [plyrSources]="plyrSources"
      (plyrInit)="contentPlyr = $event;">
</plyr>
<!--<div *ngIf="canDownload && audioLoaded" class="row">
  <div class="col-md-2">
    <a *ngIf="!audioDownloading"
       (click)="downloadAudioFile(outputFormatTypeSel)"
       class="fa fa-download fa-lg"
       tooltip="Download audio"
       container="body">
    </a>
    <span *ngIf="audioDownloading"
          class="fa fa-spinner fa-spin fa-lg">
  </span>
  </div>
  <div class="col-md-10">
    <label *ngFor="let outputFormatTypeValue of outputFormatTypesValues" class="radio-inline control-label">
      <input [(ngModel)]="outputFormatTypeSel"
             [value]="outputFormatTypeValue"
             type="radio"
             name="outputFormatTypeGrp"> {{outputFormatTypeValue}}
    </label>
  </div>
</div>-->
<a *ngIf="canDownload && audioLoaded && !audioDownloading"
   (click)="downloadAudioFile(outputFormatTypeSel)"
   class="fa fa-download fa-lg"
   tooltip="Download audio"
   container="body">
</a>
